import { Profile } from '@graphql/__generated__/graphql';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ProfileBioProps } from '@stadionhq-v3/football-ui';
import { Translations } from '@lib/dictionary-keys/__generated__';
import ContentfulRichTextRenderer, {
  RteDictionary,
} from '@components/helpers/contentful-rich-text-render';
import { DocumentLinks } from '@stadionhq-v3/core';
import { SocialLinkProps } from '@stadionhq-v3/base-ui';

const profileBioTransform = (
  {
    firstName,
    lastName,
    bioTitle,
    summary,
    biography,
    socialChannels,
  }: CleanContentful<Profile>,
  dictionary: {
    followSocial: Translations['profile']['label']['followOnSocial'];
  } & RteDictionary
): ProfileBioProps => ({
  firstName: firstName as string,
  lastName: lastName as string,
  title: bioTitle,
  summary,
  socialLinks:
    socialChannels?.channels?.map((channel: SocialLinkProps) => ({
      ...channel,
      variant: 'secondary',
    })) ?? undefined,
  content: biography?.json ? (
    <ContentfulRichTextRenderer
      document={{
        json: biography?.json,
        links: biography?.links as DocumentLinks,
      }}
      dictionary={dictionary}
    />
  ) : undefined,
});

export default profileBioTransform;
